import { ReactComponent as ChevronLeftIcon } from "assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "assets/icons/chevron-right.svg";
import getMonth from "date-fns/getMonth";
import getYear from "date-fns/getYear";

const MONTHS = [
    "Siječanj",
    "Veljača",
    "Ožujak",
    "Travanj",
    "Svibanj",
    "Lipanj",
    "Srpanj",
    "Kolovoz",
    "Rujan",
    "Listopad",
    "Studeni",
    "Prosinac",
];

export function Navbar(props: any) {
    const currentDate = `${MONTHS[getMonth(props.month)].toLocaleUpperCase()} ${getYear(
        props.month
    )}`;
    return (
        <div className={props.className}>
            <ChevronLeftIcon
                onClick={() => props.onPreviousClick()}
                className="day-picker-control"
            />
            {currentDate}
            <ChevronRightIcon onClick={() => props.onNextClick()} className="day-picker-control" />
        </div>
    );
}
